import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#E0EDEF"
        stroke="#E0EDEF"
        strokeWidth={1.2}
        d="M9.818 10.318A5.381 5.381 0 0 1 6 11.9a5.382 5.382 0 0 1-3.818-1.582A5.381 5.381 0 0 1 .6 6.5c0-1.491.604-2.84 1.582-3.818A5.381 5.381 0 0 1 6 1.1c1.491 0 2.84.604 3.818 1.582A5.381 5.381 0 0 1 11.4 6.5c0 1.491-.604 2.84-1.582 3.818Z"
      />
      <path
        fill="#212326"
        stroke="#212326"
        strokeWidth={0.25}
        d="M6 3.375a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
      />
      <path fill="#212326" d="M6.125 9V5.5h-.5" />
      <path stroke="#212326" d="M6.125 9V5.5h-.5" />
      <path fill="#212326" d="M5.25 9H7 5.25Z" />
      <path stroke="#212326" d="M5.25 9H7" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .5h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
